//import own 
import '../../appStyles.css'
import './Scan.css';

//imports react
import React, {
    useEffect,
    useRef,

} from 'react';

import ReactDOM from 'react-dom'

import { Link, useParams } from 'react-router-dom';

import Webcam from "react-webcam";

const Scan = () => {

    const videoRef = useRef(null);
    const photoRef = useRef(null);

    // eslint-disable-next-line no-unused-vars
    const [hasPhoto, setHasPhoto] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [localStream, setLocalStream] = React.useState(null);

    //retrieving params from url als deze '0' terug geeft -> dan moet er een group gekozen worden aan de hand van een dropdown. als deze niet '0' geeft maar een id van een group dan moet de gebruiker geen groep aanduiden.
    const { groupId } = useParams();
    const { expenseId } = useParams();


    /*const getVideo = () => {
        
        navigator.mediaDevices.getUserMedia({ 
            video : { width: 1080, height: 1920}
        })
        .then(stream => {
            let video = videoRef.current;
            video.srcObject = stream;
            setLocalStream(stream);
            video.play();

            document.getElementsByTagName('video')[0].play()
            
            document.getElementsByClassName('btnTakePhoto')[0].style.display = 'flex';
            document.getElementsByClassName('btnGetVideo')[0].style.display = 'none';
        })
        .catch(err => {
            document.getElementsByClassName('photoErrorMessage')[0].innerHTML = err;
            
        }); 
    }*/




    const videoConstraints = {
        width: 1920,
        height: 1080,
        facingMode: "environment"
    };



    const capture = React.useCallback(
        () => {




            const imageSrc = videoRef.current.getScreenshot();
            photoRef.current.src = imageSrc;

            document.getElementsByTagName('video')[0].style.display = 'none';
            document.getElementsByClassName('btnTakePhoto')[0].style.display = 'none';
            document.getElementsByClassName('retakePhoto')[0].style.display = 'flex';
            document.getElementsByClassName('photoRect')[0].style.display = 'flex';
            document.getElementsByClassName('linkBackInsertExpense')[0].style.display = 'inline-block';

            setHasPhoto(true);
        },
        [videoRef]
    );


    //Page title
    useEffect(() => {
        document.title = 'Scan';
    }, []);

    return (
        <div style={{ height: '100vh' }}>
            <h1 className="header">Picture Expense</h1>

            <p style={{ fontSize: '20px', color: 'lightslategray' }}>Take a Photo of your Ticket</p>
            <div className="camera"  >
                <p className='errorMessage photoErrorMessage'></p>
                <div className="webCamPlaceholder">

                </div>
                <img className='photoRect' ref={photoRef} style={{ maxWidth: '80%', borderRadius: '0.25rem' }} alt='' /><br />
                <button className='btnTakePhoto' onClick={capture}></button>
                <button className='retakePhoto' onClick={closePhoto}>Retake Photo</button>
            </div>
            <div className="buttonsPhoto">
                <button className="btn-primary btnGetVideo" onClick={getVideo} >Take Photo</button>
                <Link className='linkBackInsertExpense' style={{ width: '82.5%' }} onClick={vidOff} to={{ pathname: `/insertExpense/${groupId}/${expenseId}`, photo: photoRef.current }} ><button className="btn-primary" >Save</button></Link>
                <button className="btn-secondary" onClick={back} >Back</button>
            </div>
        </div>
    );

    function getVideo() {
        ReactDOM.render(
            <Webcam 
                screenshotFormat="image/jpeg" 
                screenshotQuality={1} 
                ref={videoRef} 
                videoConstraints={videoConstraints} 
                audio={false} />, 
            document.getElementsByClassName('webCamPlaceholder')[0]);

        document.getElementsByTagName('video')[0].style.display = 'flex';
        document.getElementsByClassName('btnTakePhoto')[0].style.display = 'flex';
        document.getElementsByClassName('photoRect')[0].style.display = 'none';
        document.getElementsByClassName('retakePhoto')[0].style.display = 'none';
        document.getElementsByClassName('linkBackInsertExpense')[0].style.display = 'none';
        document.getElementsByClassName('btnGetVideo')[0].style.display = 'none';

    }

    function closePhoto() {
        document.getElementsByTagName('video')[0].style.display = 'flex';
        document.getElementsByClassName('btnTakePhoto')[0].style.display = 'flex';
        document.getElementsByClassName('photoRect')[0].style.display = 'none';
        document.getElementsByClassName('retakePhoto')[0].style.display = 'none';
        document.getElementsByClassName('linkBackInsertExpense')[0].style.display = 'none';
        setHasPhoto(true);
    }

    async function back() {

        goback();

        function clear(_callback) {
            vidOff();
            _callback();
        }

        function goback() {
            clear(function () {
                window.history.back();
            });
        }
    }

    function vidOff() {
        const errorMessage = document.getElementsByClassName('photoErrorMessage')[0];
        try {
            videoRef.current.pause();
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            localStream.getTracks().forEach(track => {
                track.stop();
            });
        } catch (error) {
            errorMessage.innerHTML = "Problem closing video sources" + error;
        }
    }
};

export default Scan;